import React from "react";

import "../styles/style.scss";

export const About = () => {
  return (
    <div className="hero mb-12">
      <p>
        Embarking on my professional journey in 2018, I swiftly embraced the world of front-end development, harnessing my skills in HTML, CSS, and JavaScript
        to create captivating digital experiences.
      </p>

      <p>
        Over time, my expertise expanded to encompass advanced styling techniques using SASS/SCSS, and I adeptly navigated through the complexities of popular
        front-end frameworks like Angular and React.
      </p>
    </div>
  );
};

